import ImageProcessor from "./components/ImageProcessor";

function App() {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <ImageProcessor />
    </div>
  );
}

export default App;

